import { Vector3 } from 'three';

export class StoredViewport {
    left: number;
    right: number;
    top: number;
    bottom: number;
    viewSize: number;
    position: Vector3;
    up: Vector3;
    look_vector: Vector3;
    look_target: Vector3;
    name: string;

    constructor(left: number, right: number, top: number, bottom: number, viewSize: number, position: Vector3, up: Vector3, look_vector: Vector3, look_target: Vector3, name: string) {
        this.left = left;
        this.right = right;
        this.top = top;
        this.bottom = bottom;
        this.viewSize = viewSize;
        this.position = new Vector3().copy(position);
        this.up = new Vector3().copy(up);
        this.look_vector = new Vector3().copy(look_vector);
        this.look_target = new Vector3().copy(look_target);
        this.name = name;
    }
}
